import { Table, Tag } from 'antd';
import { DatePickerFilter } from 'components/Filters/DatePickerFilter';
import { FilterIcon } from 'components/Filters/FilterIcon';
import { SelectTableFilter } from 'components/Filters/SelectTableFilter';
import {
  COLUMN_MEDIUM,
  COLUMN_SMALL,
  PAGE_SIZE_OPTIONS,
  SCROLL_Y,
} from 'constants/table';
import React from 'react';
import { formatDate } from 'utils';
import {
  paymentStatusToText,
  paymentStatuses,
} from 'utils/handbooks/paymentsHandbook';
import { priceRender, renderWithTooltip } from 'utils/table';

function CardReversalPaymentsTable({
  items,
  current,
  pageSize,
  loading,
  totalRows,
  filters = {},
  onChange,
  onRowClick,
  onFilter,
}) {
  const { period, status } = filters;

  const columns = [
    {
      title: 'Клиент',
      key: 'company_name',
      dataIndex: 'company_name',
      fixed: 'left',
      width: 250,
      render: (value) => renderWithTooltip(value, 60),
    },
    {
      title: '№',
      key: 'order',
      dataIndex: 'order',
    },
    {
      title: 'Сумма платежа	',
      key: 'org_amount',
      dataIndex: 'org_amount',
      render: priceRender,
    },
    {
      title: 'Сумма возврата',
      key: 'amount',
      dataIndex: 'amount',
      render: priceRender,
    },
    {
      title: '№ транзакции',
      key: 'rrn',
      dataIndex: 'rrn',
      width: COLUMN_SMALL,
    },
    {
      title: '№ платежа банка',
      key: 'int_ref',
      dataIndex: 'int_ref',
      width: COLUMN_MEDIUM,
    },
    {
      title: 'Дата',
      key: 'timestamp',
      dataIndex: 'timestamp',
      render: (date) => formatDate(date, 'DD.MM.YYYY, HH.mm'),
      filterDropdown: () => {
        return (
          <DatePickerFilter
            value={period}
            picker="month"
            format="MM.YYYY"
            returnFormat="YYYY-MM"
            getDate={(period) => onFilter({ period })}
          />
        );
      },
      filterIcon: () => <FilterIcon search isActive={period} />,
    },
    {
      title: 'Статус',
      key: 'status',
      dataIndex: 'status',
      render: (status) => {
        return <Tag>{paymentStatusToText[status] || status}</Tag>;
      },
      filterDropdown: () => {
        return (
          <SelectTableFilter
            dataSourse={paymentStatuses}
            value={status}
            itemKey="value"
            itemValue="text"
            placeholder="Выберите cтатус"
            getSelectedItem={(status) => onFilter({ status })}
          />
        );
      },
      filterIcon: () => <FilterIcon isActive={status} />,
    },
    {
      title: 'Терминал',
      key: 'terminal',
      dataIndex: 'terminal',
    },
    {
      title: 'Описание',
      key: 'desc',
      dataIndex: 'desc',
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      scroll={{ x: 1600, y: SCROLL_Y }}
      pagination={{
        total: totalRows,
        current,
        pageSize,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      rowKey="id"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { CardReversalPaymentsTable };
